import React from "react";
import Table from "./Table";
import Grafico from "./Grafico";


class TabOfertaFinal extends React.Component {
    componentDidMount() { }

    filtroPorTipo = (rows, tipo) => {
        return rows.filter((index) => { if (index.tipo == tipo) { return index } });
    }
    validate = (data) => {
        return data != undefined && data != [] && data.length != 0;
    }
    render() {

        let exibirTabelas = true;
        let exibirGraficos = this.props.state.exibirGraficos;
        return (
            <>
                {this.props.state.tipos.some(option => option.label === 'Vertical')
                    && this.validate(this.props.state.dataOfertaFinalTipologia)
                    && this.validate(this.props.state.dataOfertaFinalTipo)
                    &&
                    <>
                        {exibirTabelas && <Table exibirTabelas={this.props.state.exibirTabelas}
                            tipo_detalhamento='Tipologia'
                            titulo='Oferta Final Vertical Por Tipologia'
                            rows={this.props.state.dataOfertaFinalTipologia.ofertaFinal}
                            detalhesLabel={this.props.state.detalhesLabel}
                            response_period_type={this.props.state.response_period_type}
                            periodos={this.props.state.periodos}
                            setLoading={this.setLoading}
                            variacao={this.props.state.response_variacao}
                            periodos_variacao={this.props.state.periodos_variacao}
                            totais={this.filtroPorTipo(this.props.state.dataOfertaFinalTipo.ofertaFinal, "Vertical")}
                            id="excel17"
                        />}
                        {exibirGraficos && <Grafico
                            tipo_detalhamento='Tipologia'
                            titulo='Oferta Final Vertical Por Tipologia'
                            rows={this.props.state.dataOfertaFinalTipologia.ofertaFinal}
                            detalhesLabel={this.props.state.detalhesLabel}
                            response_period_type={this.props.state.response_period_type}
                            periodos={this.props.state.periodos}
                            setLoading={this.setLoading}
                            variacao={this.props.state.response_variacao}
                            periodos_variacao={this.props.state.periodos_variacao}
                        />}
                        {exibirTabelas && <Table exibirTabelas={this.props.state.exibirTabelas}
                            tipo_detalhamento='Tipologia'
                            titulo='VGV Oferta Final Por Tipologia'
                            rows={this.props.state.dataOfertaFinalTipologia.vgv}
                            detalhesLabel={this.props.state.detalhesLabel}
                            response_period_type={this.props.state.response_period_type}
                            periodos={this.props.state.periodos}
                            setLoading={this.setLoading}
                            variacao={this.props.state.response_variacao}
                            periodos_variacao={this.props.state.periodos_variacao}
                            totais={this.filtroPorTipo(this.props.state.dataOfertaFinalTipo.vgv, "Vertical")}
                            id="excel18"
                        />}
                        {exibirGraficos && <Grafico
                            tipo_detalhamento='Tipologia'
                            titulo='VGV Oferta Final Por Tipologia'
                            rows={this.props.state.dataOfertaFinalTipologia.vgv}
                            detalhesLabel={this.props.state.detalhesLabel}
                            response_period_type={this.props.state.response_period_type}
                            periodos={this.props.state.periodos}
                            setLoading={this.setLoading}
                            variacao={this.props.state.response_variacao}
                            periodos_variacao={this.props.state.periodos_variacao}
                        />}
                    </>
                }
                {this.validate(this.props.state.dataOfertaFinalPadrao) &&
                    this.validate(this.props.state.dataOfertaFinalTipo) &&
                    <>
                        {
                            this.props.state.tipos.some(option => option.label === 'Vertical') &&
                            <>
                                {exibirTabelas && <Table exibirTabelas={this.props.state.exibirTabelas}
                                    tipo_detalhamento='Padrão'
                                    titulo='Oferta Final Vertical por Padrão'
                                    rows={this.filtroPorTipo(this.props.state.dataOfertaFinalPadrao.ofertaFinal, "Vertical")}
                                    detalhesLabel={this.props.state.detalhesLabel}
                                    response_period_type={this.props.state.response_period_type}
                                    periodos={this.props.state.periodos}
                                    setLoading={this.setLoading}
                                    variacao={this.props.state.response_variacao}
                                    periodos_variacao={this.props.state.periodos_variacao}
                                    totais={this.filtroPorTipo(this.props.state.dataOfertaFinalTipo.ofertaFinal, "Vertical")}
                                    id="excel19"
                                />}
                                {exibirGraficos && <Grafico
                                    tipo_detalhamento='Padrão'
                                    titulo='Oferta Final Vertical por Padrão'
                                    rows={this.filtroPorTipo(this.props.state.dataOfertaFinalPadrao.ofertaFinal, "Vertical")}
                                    detalhesLabel={this.props.state.detalhesLabel}
                                    response_period_type={this.props.state.response_period_type}
                                    periodos={this.props.state.periodos}
                                    setLoading={this.setLoading}
                                    variacao={this.props.state.response_variacao}
                                    periodos_variacao={this.props.state.periodos_variacao}
                                />}
                                {exibirTabelas && <Table exibirTabelas={this.props.state.exibirTabelas}
                                    tipo_detalhamento='Padrão'
                                    titulo='VGV Oferta Final Vertical Por Padrão'
                                    rows={this.filtroPorTipo(this.props.state.dataOfertaFinalPadrao.vgv, "Vertical")}
                                    detalhesLabel={this.props.state.detalhesLabel}
                                    response_period_type={this.props.state.response_period_type}
                                    periodos={this.props.state.periodos}
                                    setLoading={this.setLoading}
                                    variacao={this.props.state.response_variacao}
                                    periodos_variacao={this.props.state.periodos_variacao}
                                    totais={this.filtroPorTipo(this.props.state.dataOfertaFinalTipo.vgv, "Vertical")}
                                    id="excel20"

                                />}
                                {exibirGraficos && <Grafico
                                    tipo_detalhamento='Padrão'
                                    titulo='VGV Oferta Final Vertical Por Padrão'
                                    rows={this.filtroPorTipo(this.props.state.dataOfertaFinalPadrao.vgv, "Vertical")}
                                    detalhesLabel={this.props.state.detalhesLabel}
                                    response_period_type={this.props.state.response_period_type}
                                    periodos={this.props.state.periodos}
                                    setLoading={this.setLoading}
                                    variacao={this.props.state.response_variacao}
                                    periodos_variacao={this.props.state.periodos_variacao}
                                />}
                            </>
                        }

                        {this.props.state.tipos.some(option => option.label === 'Horizontal') &&
                            <>
                                {exibirTabelas && <Table exibirTabelas={this.props.state.exibirTabelas}
                                    tipo_detalhamento='Padrão'
                                    titulo='Oferta Final Horizontal'
                                    rows={this.filtroPorTipo(this.props.state.dataOfertaFinalPadrao.ofertaFinal, "Horizontal")}
                                    detalhesLabel={this.props.state.detalhesLabel}
                                    response_period_type={this.props.state.response_period_type}
                                    periodos={this.props.state.periodos}
                                    setLoading={this.setLoading}
                                    variacao={this.props.state.response_variacao}
                                    periodos_variacao={this.props.state.periodos_variacao}
                                    totais={this.filtroPorTipo(this.props.state.dataOfertaFinalTipo.ofertaFinal, "Horizontal")}
                                    id="excel21"

                                />}
                                {exibirGraficos && <Grafico
                                    tipo_detalhamento='Padrão'
                                    titulo='Oferta Final Horizontal'
                                    rows={this.filtroPorTipo(this.props.state.dataOfertaFinalPadrao.ofertaFinal, "Horizontal")}
                                    detalhesLabel={this.props.state.detalhesLabel}
                                    response_period_type={this.props.state.response_period_type}
                                    periodos={this.props.state.periodos}
                                    setLoading={this.setLoading}
                                    variacao={this.props.state.response_variacao}
                                    periodos_variacao={this.props.state.periodos_variacao}
                                />}
                                {exibirTabelas && <Table exibirTabelas={this.props.state.exibirTabelas}
                                    tipo_detalhamento='Padrão'
                                    titulo='VGV Oferta Final Horizontal'
                                    rows={this.filtroPorTipo(this.props.state.dataOfertaFinalPadrao.vgv, "Horizontal")}
                                    detalhesLabel={this.props.state.detalhesLabel}
                                    response_period_type={this.props.state.response_period_type}
                                    periodos={this.props.state.periodos}
                                    setLoading={this.setLoading}
                                    variacao={this.props.state.response_variacao}
                                    periodos_variacao={this.props.state.periodos_variacao}
                                    totais={this.filtroPorTipo(this.props.state.dataOfertaFinalTipo.vgv, "Horizontal")}
                                    id="excel22"

                                />}
                                {exibirGraficos && <Grafico
                                    tipo_detalhamento='Padrão'
                                    titulo='VGV Oferta Final Horizontal'
                                    rows={this.filtroPorTipo(this.props.state.dataOfertaFinalPadrao.vgv, "Horizontal")}
                                    detalhesLabel={this.props.state.detalhesLabel}
                                    response_period_type={this.props.state.response_period_type}
                                    periodos={this.props.state.periodos}
                                    setLoading={this.setLoading}
                                    variacao={this.props.state.response_variacao}
                                    periodos_variacao={this.props.state.periodos_variacao}
                                />}
                            </>}

                        {this.props.state.tipos.some(option => option.label === 'Comercial') &&
                            <>
                                {exibirTabelas && <Table exibirTabelas={this.props.state.exibirTabelas}
                                    tipo_detalhamento='Padrão'
                                    titulo='Oferta Final Comercial'
                                    rows={this.filtroPorTipo(this.props.state.dataOfertaFinalPadrao.ofertaFinal, "Comercial")}
                                    detalhesLabel={this.props.state.detalhesLabel}
                                    response_period_type={this.props.state.response_period_type}
                                    periodos={this.props.state.periodos}
                                    setLoading={this.setLoading}
                                    variacao={this.props.state.response_variacao}
                                    periodos_variacao={this.props.state.periodos_variacao}
                                    totais={this.filtroPorTipo(this.props.state.dataOfertaFinalTipo.ofertaFinal, "Comercial")}
                                    id="excel23"

                                />}
                                {exibirGraficos && <Grafico
                                    tipo_detalhamento='Padrão'
                                    titulo='Oferta Final Comercial'
                                    rows={this.filtroPorTipo(this.props.state.dataOfertaFinalPadrao.ofertaFinal, "Comercial")}
                                    detalhesLabel={this.props.state.detalhesLabel}
                                    response_period_type={this.props.state.response_period_type}
                                    periodos={this.props.state.periodos}
                                    setLoading={this.setLoading}
                                    variacao={this.props.state.response_variacao}
                                    periodos_variacao={this.props.state.periodos_variacao}
                                />}
                                {exibirTabelas && <Table exibirTabelas={this.props.state.exibirTabelas}
                                    tipo_detalhamento='Padrão'
                                    titulo='VGV Oferta Final Comercial'
                                    rows={this.filtroPorTipo(this.props.state.dataOfertaFinalPadrao.vgv, "Comercial")}
                                    detalhesLabel={this.props.state.detalhesLabel}
                                    response_period_type={this.props.state.response_period_type}
                                    periodos={this.props.state.periodos}
                                    setLoading={this.setLoading}
                                    variacao={this.props.state.response_variacao}
                                    periodos_variacao={this.props.state.periodos_variacao}
                                    totais={this.filtroPorTipo(this.props.state.dataOfertaFinalTipo.vgv, "Comercial")}
                                    id="excel24"

                                />}
                                {exibirGraficos && <Grafico
                                    tipo_detalhamento='Padrão'
                                    titulo='VGV Oferta Final Comercial'
                                    rows={this.filtroPorTipo(this.props.state.dataOfertaFinalPadrao.vgv, "Comercial")}
                                    detalhesLabel={this.props.state.detalhesLabel}
                                    response_period_type={this.props.state.response_period_type}
                                    periodos={this.props.state.periodos}
                                    setLoading={this.setLoading}
                                    variacao={this.props.state.response_variacao}
                                    periodos_variacao={this.props.state.periodos_variacao}
                                />}
                            </>}
                    </>
                }
            </>
        );
    }
}

export default TabOfertaFinal;
